import React, { ReactNode } from 'react';

import { DavCalendarEvent } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import { JRCTypography } from '../../JRCTypography/JRCTypography';
import { Container, CSSEventItem, CssEventItemStatus, Status, CSSEventItemA } from './styles';
import { JRCDate } from 'components/JRCDate/JRCDate';
import { isSameDay } from 'utils/utils.date';

export type JRCWidgetCalendarCalDavProps = { calendarListEvent: DavCalendarEvent[] };

export const JRCWidgetCalendarCalDav = ({ calendarListEvent }: JRCWidgetCalendarCalDavProps) => {
    const intl = useIntl();
    return (
        <Container>
            {calendarListEvent.length
                ? calendarListEvent.map((event: DavCalendarEvent, index: number) => {
                      if (index == 0) {
                          event.status = 'accepted';
                      }
                      if (index == 1) {
                          event.status = 'declined';
                      }
                      return (
                          <EventItem key={`event-item-${index}`} event={event}>
                              <JRCTypography weight="medium" color="grey6">
                                  {event.summary}
                              </JRCTypography>
                              <EventItemDate dateStart={event.start} dateEnd={event.end} />
                              <Status>
                                  <CssEventItemStatus status={event.status} />
                                  <JRCTypography size="s" weight="medium" color={'grey6'}>
                                      {event.status == 'pending' ? (
                                          intl.formatMessage({ id: 'WIDGET_Agenda_Pending' })
                                      ) : event.status == 'accepted' ? (
                                          intl.formatMessage({ id: 'WIDGET_Agenda_Accepted' })
                                      ) : event.status == 'declined' ? (
                                          intl.formatMessage({ id: 'WIDGET_Agenda_Declined' })
                                      ) : (
                                          <></>
                                      )}
                                  </JRCTypography>
                              </Status>
                          </EventItem>
                      );
                  })
                : intl.formatMessage({ id: 'GLOBAL_No_Result' })}
        </Container>
    );
};

export const EventItem = ({ event, children }: { event: DavCalendarEvent; children: ReactNode }) => {
    return event.url ? (
        <CSSEventItemA
            href={event.url}
            status={event.status}
            aria-label={event.summary}
            target="_blank"
            rel="noreferrer">
            {children}
        </CSSEventItemA>
    ) : (
        <CSSEventItem status={event.status}>{children}</CSSEventItem>
    );
};

export const EventItemDate = ({ dateStart, dateEnd }: { dateStart: string; dateEnd: string }) => {
    const sameDay = isSameDay(dateStart, dateEnd);
    return (
        <JRCTypography size="s">
            <JRCDate date={dateStart} smartDate={true} format={'date-time'} />
            {' - '}
            <JRCDate date={dateEnd} smartDate={!sameDay} format={sameDay ? 'time' : 'date-time'} />
        </JRCTypography>
    );
};
